import { render, staticRenderFns } from "./comp-first-dialog.vue?vue&type=template&id=3eb0913f&scoped=true"
import script from "./comp-first-dialog.vue?vue&type=script&lang=js"
export * from "./comp-first-dialog.vue?vue&type=script&lang=js"
import style0 from "./comp-first-dialog.vue?vue&type=style&index=0&id=3eb0913f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb0913f",
  null
  
)

export default component.exports